import { render, staticRenderFns } from "./ProCardHeaderNew.vue?vue&type=template&id=ac1ca86c&scoped=true"
import script from "./ProCardHeaderNew.vue?vue&type=script&lang=js"
export * from "./ProCardHeaderNew.vue?vue&type=script&lang=js"
import style0 from "./ProCardHeaderNew.vue?vue&type=style&index=0&id=ac1ca86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ca86c",
  null
  
)

export default component.exports